import { request } from 'app/utils';
import { Col, Flex, Loading, Page, Row, Section, Typography } from 'components';
import { DashboardVisualizationTypeEnum } from 'features/dashboard-new';
import { SchoolDashboardAreaSearchResponse } from 'features/dashboard-new/types/SchoolDashboardAreaSearchResponse';
import useSheets from 'features/dashboard-new/useSheets';
import { ProductsCardNew } from 'features/products';
import { useSchool } from 'features/school';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const Search = () => {
  const [loading, setLoading] = useState(true);

  const { dashboardAreaUuid } = useParams();

  const { apiGatewayUrl } = useSchool();
  const { dashboardAreaSearch, setDashboardAreaSearch, clearDashboardAreaSearch, sheetTheme } = useSheets();

  const theme = sheetTheme(DashboardVisualizationTypeEnum.Standard, dashboardAreaSearch?.dashboardAreaColor);

  const fetchDashboardArea = useCallback(async () => {
    setLoading(true);

    await request<SchoolDashboardAreaSearchResponse>({
      url: `/api/v1/School/Dashboard/SearchArea/${dashboardAreaUuid}`,
      baseURL: apiGatewayUrl,
      method: 'get',
    })
      .then(({ data }) => {
        setDashboardAreaSearch(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dashboardAreaUuid]);

  useEffect(() => {
    fetchDashboardArea();

    return () => {
      clearDashboardAreaSearch();
    };
  }, [dashboardAreaUuid]);

  if (loading) return <Loading label="Por favor, aguarde." />;

  return (
    <Page title={dashboardAreaSearch?.name}>
      <Flex py={{ m: 30, t: 60, d: 90 }} className="dashboard-area" flexGrow={0} bg={theme.sheetBg}>
        <Section flexDirection="column" flexGrow={0}>
          <Flex mb={5} alignItems="center" justifyContent="space-between">
            <Flex flexDirection="column">
              {!!dashboardAreaSearch?.hat && (
                <Typography type="type3" upper mb={1} color={theme.titleColor}>
                  {dashboardAreaSearch?.hat}
                </Typography>
              )}

              <Typography as="h2" type="type8" fontWeight="bold" color={theme.titleColor}>
                {dashboardAreaSearch.name}
              </Typography>
            </Flex>
          </Flex>

          <Row gutter={20} mt={6}>
            {dashboardAreaSearch?.cards.map((card, index) => {
              return (
                <Col key={`sheet-carousel${index.toString()}-${card.uuid}`} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mb={4}>
                  <ProductsCardNew
                    card={card}
                    dashboardAreaColor={dashboardAreaSearch.dashboardAreaColor}
                    dashboardVisualizationType={DashboardVisualizationTypeEnum.Standard}
                  />
                </Col>
              );
            })}
          </Row>
        </Section>
      </Flex>
    </Page>
  );
};

export default Search;
